export default __webpack_public_path__ + "static/media/three.d8e23f29.svg";